import styled from 'styled-components';

export const NonprofitMediaGallery = styled.div`
    width: 100%;
    padding: 20px;
    background: #FFFFFF;
    border-radius: 15px;
    box-shadow: 0px 10px 10px #0000000D;
`;  

export const MediaGallerySubTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 10px;
`;

export const MediaGalleryImagGroup = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
     gap: 20px;
    flex-wrap: wrap;
`;

export const MediaGalleryBox = styled.div`
    width: 100%;
    background: #F3F3F3;
    padding: 24px;
    border-radius: 10px;
    min-height: 530px; 
`;

export const MediaGalleryImageBox = styled.div`
    max-width: 206px;
    max-height: 160px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
 @media screen and (max-width:991px){
      max-width: 203px;
 }	
 @media screen and (max-width:767px){
   max-width: inherit;
 }
    img{
      width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    min-height: 166px;
    }
`;

export const PlayButton = styled.button`
    width: 52px;
    height: 52px;
    background: #01606f;
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    border-radius: 50%;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease-in-out;
    &:hover{
        background: #f9dc70;
    }

    img{
        width: 17px;
        height: 21px;
        margin-left: 4px;
        display: block;
    }
`;

export const SectionTitle = styled.div``;

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;
    @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }
`;

export const SectionButton = styled.button`
    margin-bottom: 30px;

    &.btn-outline-success-blue{
        padding: 12px 29px;
        &::focus-visible {
            box-shadow:  none;
        }
    }
`;
